
const bannerInfo = {
    id:1,
    titleList:[
        {
            provinceId:1,
            title:'Western Sichuan',
        },
        {
            provinceId:2,
            title:'Western Chongqing',
        },
        {
            provinceId:3,
            title:'Eastern Guangzhou',
        }
    ],
    desc:'Please find our rates, booking form,  terms and conditions below.',
    itemList:[
        {
            id:1,
            provinceId:1,
            timeList:[
                {
                    id:1,
                    content:'3 Days',
                },
                {
                    id:2,
                    content:'14 Destination',
                },
            ],
            serviceList:[
                {
                    id:1,
                    content:'Optional Star-Rated Hote',
                },
                {
                    id:2,
                    content:'Various Models Available',
                },
            ],
            locationList:['Siguniang Mountain','Bipenggou ','Jiuzhaigou','Lianbao Yeze','Langyi Temple'],
        },
        {
            id:2,
            provinceId:1,
            timeList:[
                {
                    id:1,
                    content:'5-7 Days',
                },
                {
                    id:2,
                    content:'17 Destination',
                },
            ],
            serviceList:[
                {
                    id:1,
                    content:'Optional Star-Rated Hote',
                },
                {
                    id:2,
                    content:'Various Models Available',
                },
            ],
            locationList:['Yuzixi','Zheduo Mountain','Moshi Park','The Eye of Genie','Daocheng Yading','Shuangqiao Valley'],
        },
        {
                id:3,
                provinceId:1,
                timeList:[
                    {
                        id:1,
                        content:'3-7 Days',
                    },
                    {
                        id:2,
                        content:'8-13Destinations',
                    },
                ],
                serviceList:[
                    {
                        id:1,
                        content:'Optional Star-Rated Hote',
                    },
                    {
                        id:2,
                        content:'Various Models Available',
                    },
                ],
            locationList:['Giant Panda Breeding Research Base','Kuan & Zhai Alley ','Chunxi Road Business District'],//,'Dujiangyan Scenic Area','Sichuan Museum','East Gate Memory'
        },
        {
            id:4,
            provinceId:2,
            timeList:[
                {
                    id:1,
                    content:'3-5 Days',
                },
                {
                    id:2,
                    content:'12-15 Destinations',
                },
            ],
            serviceList:[
                {
                    id:1,
                    content:'Optional Star-Rated Hote',
                },
                {
                    id:2,
                    content:'Various Models Available',
                },
            ],
            locationList:['Jiefangbei','Liziba ','Hongyadong','Yangtze River Cableway'],//,'Xiannvshan National Forest Park','Wulong Tiankeng Three Bridges'
        },
        {
            id:5,
            provinceId:3,
            timeList:[
                {
                    id:1,
                    content:'3-5 Days',
                },
                {
                    id:2,
                    content:'6 Destinations',
                },
            ],
            serviceList:[
                {
                    id:1,
                    content:'Optional Star-Rated Hote',
                },
                {
                    id:2,
                    content:'Various Models Available',
                },
            ],
        locationList:['Yongqing Fang','Panxi Restaurant ','Guangdong Museum','The Ancient Nanfeng'],//,'Xiannvshan National Forest Park','Wulong Tiankeng Three Bridges'
        }
    ]
}
export default {
    bannerInfo
}